import React from 'react';   
import styled from 'styled-components'; 
 
export default function UserDetailCategoryScene({parentCategories, selectedItems, firstCategories, secondCategories , onToggle}) {
    return (<SceneSection>
            <SectionHeader> 
                    <HeaderTitle>마지막 단계예요!<br />세부 관심사를 선택해 주세요</HeaderTitle>  
            </SectionHeader>
            <SectionBody>
                {
                    (Array.isArray(parentCategories)&& parentCategories.map((parentItem, parentIndex)=>{
                        let detailList = []
                        if(parentIndex === 0)
                        {
                            detailList = firstCategories;
                        }
                        else if(parentIndex === 1)
                        {
                            detailList = secondCategories;
                        }
                        return (
                            <DetailCategorySection key={`parent-category-section-no-${parentItem['no']}`}>
                                <ParentTitle>
                                    <ParentTitleItem>{parentItem['name']['ko']}</ParentTitleItem>
                                    <MaxThree>(최대 3개)</MaxThree>
                                </ParentTitle>
                                <DetailCategoryList>
                                    {(Array.isArray(detailList) && detailList.map((item)=>{
                                        if(selectedItems.filter((selectedItem)=>parseInt(selectedItem['no']) === parseInt(item['no'])).length > 0)
                                        {
                                            return(
                                                <DetailCategorySelectedItem key={`detail-category-section-no-${item['no']}`} onClick={()=>{if(onToggle)onToggle(item['no'])}}>{item['name']['ko']}</DetailCategorySelectedItem>
                                            ) 
                                        }
                                        else{

                                            return(
                                                <DetailCategoryItem key={`detail-category-section-no-${item['no']}`} onClick={()=>{if(onToggle)onToggle(item['no'])}}>{item['name']['ko']}</DetailCategoryItem>
                                            )   
                                        }
                                    }))}

                                </DetailCategoryList>
                            </DetailCategorySection>
                        )

                    }))
                }
            </SectionBody>

        </SceneSection>);
}


export const SceneSection = styled.div`
    height : 100%;
    padding: 0 calc(100vw * (17 / 375)); 
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow-y: scroll;
`
export const SectionHeader = styled.div`
    margin-top : calc(100vw * (16 / 375)); 
    margin-bottom : calc(100vw * (30 / 375)); 
`
 
export const HeaderTitle = styled.span`
    font-style: normal;
    font-weight: 700;
    font-size: calc(100vw * (23 / 375));
    line-height: calc(100vw * (36 / 375));
    color: #121212;
    margin-bottom : calc(100vw * (8 / 375)); 
` 

export const SectionBody = styled.div` 

`;  

export const DetailCategorySection = styled.div`
    margin-bottom : calc(100vw * (46 / 375));`

export const ParentTitle = styled.div`
    margin-bottom : calc(100vw * (20 / 375));
    display: flex;
    align-items: center;
`

export const ParentTitleItem = styled.span`
    font-weight: 600;
    font-size: calc(100vw * (18 / 375));
    line-height: calc(100vw * (22 / 375));
    color: #121212;
`

export const MaxThree = styled.span`
    font-weight: 500;
    font-size: calc(100vw * (16 / 375));
    line-height: calc(100vw * (19 / 375));
    color: #7F7F7F;
    margin-left: calc(100vw * (3 / 375));
`

export const DetailCategoryList = styled.div`
     &:after{
        display: block;
        content: " ";
        clear:both;
    }
    & > div:nth-child(3n) {
        margin-right : 0;
    }
    // & > div:nth-child(3n+1) {
    //     float:left;
    // }
`

export const DetailCategoryItem = styled.div`
    box-sizing: border-box;
    display: inline-block;
    float: left;
    width : calc(100vw * (107 / 375));
    background: #F7F7F7;
    border-radius: 2px; 
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (14 / 375));
    color: #121212;
    margin-right : calc(100vw * (10 / 375));
    text-align: center;

    padding: calc(100vw * (8 / 375)) 0;
    margin-bottom : calc(100vw * (10 / 375));
    border: 1px solid #F7F7F7;
`
export const DetailCategorySelectedItem = styled(DetailCategoryItem)`
    background: #FFF4D8;
    border: 1px solid #FFCF19;
`